export type { MultiTenantPluginConfig } from '../types.js'
